// @mui
import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
// components
// sections
import AddLeadCategoryForm from './AddLeadCategoryForm';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  // minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  // backgroundColor: 'black',
  // padding: theme.spacing(12, 0),
  padding: '0px',
}));

// ----------------------------------------------------------------------

export default function AddLeadCategory({ closePopup, handleAddSuccess }) {
  return (
    <Container>
      <ContentStyle>
        <AddLeadCategoryForm closePopup={closePopup} handleAddSuccess={handleAddSuccess} />
      </ContentStyle>
    </Container>
  );
}
